import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';


interface IProps {
    audienceImmersions: any;
  }


  const ParticipantBreakdown = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { audienceImmersions } = props;

    const [displayScore, setDisplayScore] = useState("0%");
    const [displayCategory, setDisplayCategory] = useState("Captivated");
    const [pbCommentary, setPbCommentary] = useState("Analyzing...");


    /*
audience immersions = [{"order":91,"context_indicator":"Captivated","color_indicator":"Green","tier_indicator":"Very High","category_count":0,"category_percent":0,"__typename":"contexBreakup"},
{"order":66,"context_indicator":"Absorbed","color_indicator":"Green","tier_indicator":"High","category_count":3,"category_percent":37.5,"__typename":"contexBreakup"},
{"order":36,"context_indicator":"Interested","color_indicator":"Gray","tier_indicator":"Medium","category_count":5,"category_percent":62.5,"__typename":"contexBreakup"},
{"order":11,"context_indicator":"Indifferent","color_indicator":"Red","tier_indicator":"Low","category_count":0,"category_percent":0,"__typename":"contexBreakup"},
{"order":1,"context_indicator":"Tuned Out","color_indicator":"Red","tier_indicator":"Very Low","category_count":0,"category_percent":0,"__typename":"contexBreakup"}
] 
    */

    useEffect(() => {

     // console.log("check part breakdown");

        if (!!audienceImmersions) {
          
          let found = false;
          audienceImmersions.filter(function(item: any) { return item.order === 91 && item.category_count > 0 }).forEach(function (element: any) {
            //console.log(`FOUND CAPTIVATED = ${element}`);
            //const v = Math.round(element.category_percent)
            setDisplayScore(`${Math.round(element.category_percent)}%`);
            setPbCommentary(`It is great to see ${Math.round(element.category_percent)}% of your audience captivated by your content.  This is where you want to see your most profitable demographic group. `);
            setDisplayCategory(element.context_indicator);
            found = true;
          });

          if (!found) {
            audienceImmersions.filter(function(item: any) { return item.order === 66 && item.category_count > 0 }).forEach(function (element: any) {
              //console.log(`FOUND ABSORBED = ${element}`);
              setDisplayScore(`${Math.round(element.category_percent)}%`);
              setPbCommentary(`Having ${Math.round(element.category_percent)}% of your audience absorbed in your content is pretty good. But there is still room for improvement. Make sure this group is in your preferred demographic cell.`);
              setDisplayCategory(element.context_indicator);
              found = true;
            });
          }

          if (!found) {
            audienceImmersions.filter(function(item: any) { return item.order === 36 && item.category_count > 0 }).forEach(function (element: any) {
              //console.log(`FOUND INTERESTED = ${element}`);
              setDisplayScore(`${Math.round(element.category_percent)}%`);
              setPbCommentary(`If you are not seeing most of your audience at least 'Interested' in your content, you have some real work to do. Look at your demographic groups and check your confidence score to see where you can improve.`);
              setDisplayCategory(element.context_indicator);
              found = true;
            });
          }

          if (!found) {
            audienceImmersions.filter(function(item: any) { return item.order === 11 && item.category_count > 0 }).forEach(function (element: any) {
              //console.log(`FOUND INDIFFERENT = ${element}`);
              setDisplayScore(`${Math.round(element.category_percent)}%`);
              setPbCommentary("This is probably not what you were hoping to learn. Having indifference as the primary reaction by your audience is gonna be a bummer. Look at the Actions above for ideas on how to improve this experience.");
              setDisplayCategory(element.context_indicator);
              found = true;
            });
          }

          if (!found) {
            audienceImmersions.filter(function(item: any) { return item.order < 11 && item.category_count > 0 }).forEach(function (element: any) {
              //console.log(`FOUND TuNED OUT = ${element}`);
              setDisplayScore(`${Math.round(element.category_percent)}%`);
              setPbCommentary("Yikes. This audience did not value the experience at all. We have some work to do. Look at the actions outlined above to improve this content.");
              setDisplayCategory(element.context_indicator);
              found = true;
            });
          }


         
          


           
        }
      }, [props]);
    
      const goToAnalyze = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };
   
    


    return (

        <Grid item xs={4} style={{textAlign: 'center'}}>
            <Typography variant="h1" color={'primary'} className={classes.itemtitle}>{!!displayScore ? displayScore : "--"}</Typography>
            <Typography variant="body1" className={classes.sectionTitle}>{displayCategory}</Typography>
            <Typography variant="body1" className={classes.bodyText}>{pbCommentary}</Typography>
            <Link className={classes.actionLink} onClick={goToAnalyze}>
                <Typography variant="body1" className={classes.foo}>Review the Demographics</Typography>
            </Link>
          </Grid>

    )


  }

  export default ParticipantBreakdown;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));